import { render, staticRenderFns } from "./CompactEventsList.vue?vue&type=template&id=3966578d&scoped=true&"
import script from "./CompactEventsList.vue?vue&type=script&lang=js&"
export * from "./CompactEventsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3966578d",
  null
  
)

export default component.exports